import React from 'react';

import ccLogoGradient from '../../assets/cc-logo-gradient.png';
import ccLogoSquare from '../../assets/cc-logo-square-cc.png';
import ccLogoWhite from '../../assets/cc-logo-white.png';

import { ButtonLink } from '../../components/general';

type Props = {
  variant?: 'square' | 'white' | 'gradient';
  withTagLine?: boolean;
  noLink?: boolean;
  width?: string;
  className?: string;
};

const Logo = (props: Props) => {
  const { variant, withTagLine, noLink, width, className } = props;

  const getLogoImg = () => {
    switch (variant) {
      case 'square':
        return ccLogoSquare;
      case 'white':
        return ccLogoWhite;
      case 'gradient':
      default:
        return ccLogoGradient;
    }
  };

  const content = (
    <React.Fragment>
      <img
        src={getLogoImg()}
        alt="CrowdClip Logo"
        width={width || '128px'}
        className={variant === 'square' ? 'rounded-md' : ''}
      />

      {withTagLine && (
        <div className="text-xs">Bring the joy back to video</div>
      )}
    </React.Fragment>
  );

  if (noLink) return <span className={className}>{content}</span>;

  return (
    <ButtonLink to="/" variant="custom" colour="custom" className={className}>
      {content}
    </ButtonLink>
  );
};

export default Logo;
